import ManageCard from './ManageCard';

export default ManageCard;
